/*@ngInject*/
const ProductTemplateEditorHeaderController = function ($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, configurationMediator, coreConstant, modalUtil, productTemplateAction, productTemplateEditorModel, configurationActionsUtil) {

    $element.addClass('productTemplateEditorHeader');

    this.translations = null;
    this.actions = [];
    this.context = {
        identifier: 'productTemplateEditorHeader',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.actionSubTexts = {};
    this.actionsTimeLastModified = '';

    this.$onInit = function () {
        localization.getTranslationByKey('productTemplateEditorHeader').then((translations) => {
            this.translations = translations;
            this.actions = [];
            this.loadActions();
        });
    };

    this.loadActions = function () {
        const allActions = [];

        if (_.isEmpty($stateParams.productTemplateName)) {
            const staticActions = [];
            staticActions.push({
                buttonBarAction: true, context: null, contextOrdering: 0,
                enabled: true, groupName: null, groupOrdering: 0,
                importantAction: false, iwantToAction: false,
                labelKey: null, name: 'discard', nextAction: false, notes: null,
                ordering: 0, previousAction: true, valid: true
            });
            staticActions.push({
                buttonBarAction: true, context: null, contextOrdering: 0,
                enabled: true, groupName: null, groupOrdering: 0,
                importantAction: false, iwantToAction: false,
                labelKey: null, name: 'save', nextAction: true, notes: null,
                ordering: 0, previousAction: false, valid: true
            });

            allActions.push({
                actions: staticActions,
                contextType: this.context.model.contextType
            });
            this.actions = allActions;
            this.actionsTimeLastModified = new Date().getTime();
            this.processActions(allActions, false);
        } else {
            configurationMediator.loadProductTemplateActions($stateParams.productTemplateName).then((actions) => {
                allActions.push({
                    actions: actions.actions,
                    contextType: this.context.model.contextType
                });
                this.actions = allActions;
                this.actionsTimeLastModified = new Date().getTime();
                this.processActions(allActions, false);
            });
        }
    };

    this.processActions = function (actions) {
        this.actions = actions;
        this.actionSubTexts = {};

        _.each(this.actions, (subAction) => {
            _.each(subAction.actions, (action) => {
                if (action.name === productTemplateAction.SAVE) {
                    action.enabled = productTemplateEditorModel.hasUnsavedChanges && productTemplateEditorModel.isValid;
                } else if (action.name === productTemplateAction.DISCARD) {
                    action.enabled = !productTemplateEditorModel.getProductTemplate() || productTemplateEditorModel.hasUnsavedChanges;
                }

                if (action.name === productTemplateAction.SAVE && productTemplateEditorModel.hasUnsavedChanges) {
                    this.actionSubTexts[action.name] = {
                        class: 'unsavedChanges',
                        text: _.get(this.translations, 'unsavedChanges')
                    };
                }
            });
        });

        this.actionsTimeLastModified = new Date().getTime();
    };

    $scope.$on(configurationConstant.event.PRODUCT_TEMPLATE_UPDATED, () => {
        this.processActions(this.actions);
    });

    this.handleAction = function (action) {
        if (action.enabled) {
            switch (action.name) {
                case productTemplateAction.SAVE:
                    //fetch the data from productTemplateEditorModel
                    configurationActionsUtil.saveProductTemplate(productTemplateEditorModel.getProductTemplate()).then(function (productTemplate) {
                        $stateParams.productTemplateName = productTemplate.name;
                        $stateParams.productTemplateId = productTemplate.id;
                        $state.reload();
                    });
                    break;

                case productTemplateAction.DISCARD:
                    modalUtil.showConfirmationModal(null, null, null, 'productTemplateEditorHeader.discardConfirmation', null, true, () => {
                        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'discardConfirmation.success'));
                        productTemplateEditorModel.hasUnsavedChanges = false;
                        if (productTemplateEditorModel.getProductTemplate() && productTemplateEditorModel.getProductTemplate().id) {
                            $state.reload();
                        } else {
                            $state.go('configuration.productTemplateBrowser', {});
                        }
                    });
                    break;

                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        const isCurrentStateProductTemplateManager = _.startsWith(fromState.name, 'configuration.productTemplateEditor'),
            isTargetSameAsCurrent = toState.name === fromState.name;
        if (toState.name === 'login') {
            return;
        }
        if (productTemplateEditorModel.hasUnsavedChanges && isCurrentStateProductTemplateManager && !isTargetSameAsCurrent && productTemplateEditorModel.getProductTemplate()) {
            event.preventDefault();
            if (productTemplateEditorModel.isValid) {
                configurationActionsUtil.saveProductTemplate(productTemplateEditorModel.getProductTemplate()).then(function () {
                    productTemplateEditorModel.hasUnsavedChanges = false;
                    productTemplateEditorModel.isValid = false;
                    $state.go(toState, toParams);
                });
            } else {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'invalidProductTemplate'));
            }
        } else {
            // there are no changes to be saved, do nothing
        }
    });
};

angular.module('ums.configuration')
    .controller('productTemplateEditorHeaderController', ProductTemplateEditorHeaderController);
